import { CUSTOMER_SERVICE_HOURS } from '@seek/shared-constants';
import { useTranslations } from '@vocab/react';
import { Text } from 'braid-design-system';

import { useLanguage } from 'src/shared/hooks';
import type { SitesAll } from 'src/shared/types';

import translations from '../../.vocab';

const CustomerServiceHours = ({ site }: { site: SitesAll }) => {
  const siteLanguage = useLanguage();
  const { t } = useTranslations(translations);

  if (site === 'candidate-jobstreet-id' && siteLanguage === 'id-ID') {
    return <Text>{t('Customer service hours')}</Text>;
  }

  if (site === 'candidate-jobsdb-th' && siteLanguage === 'th-TH') {
    return <Text>{t('Customer service hours')}</Text>;
  }

  const typedSite = site as keyof typeof CUSTOMER_SERVICE_HOURS;

  return <Text>{CUSTOMER_SERVICE_HOURS[typedSite]}</Text>;
};

export default CustomerServiceHours;
